import { render } from "./ChooseCity.vue?vue&type=template&id=2f5b6724&scoped=true"
import script from "./ChooseCity.vue?vue&type=script&lang=js"
export * from "./ChooseCity.vue?vue&type=script&lang=js"

import "./ChooseCity.vue?vue&type=style&index=0&id=2f5b6724&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f5b6724"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon});
